import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { chambersburgConfig } from "./data";

export default function ChambersburgPage() {
  return <CityPageTemplate config={chambersburgConfig} />;
}